import React, { Component } from "react";
import {
  withStyles,
  Grid,
  Box,
  Typography,
  Button,
  CircularProgress,
  Snackbar,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { connect } from "react-redux";
import axios from "axios";
import { fetchPartnerDetails } from "../../store/partnerState";
import Header from "../../commons/Header/Header";
import plansHelper from "../../helpers/plansHelper";
import moment from "moment";
import { partnerURL, TENANT_ID } from "../../config/config";
import DateFilter from "../../commons/Filters/DateFilter";
import { checkAccess } from "../../helpers/RBAC";
import LockIcon from "@material-ui/icons/Lock";
import intercomService from "../../services/IntercomService";
import { sendIntercomAttributesAfterLogin } from "../../helpers/intercomHelper";
import RechargeModal from "./RechargeModal";
import TooltipIcon from "../../commons/TooltipIcon/TooltipIcon";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment().subtract(1, "w"),
      endDate: moment(),
      usgage: {},
      focusedInput: null,
      isLoading: false,
      rechargeModalOpen: false,
      alert: false,
      alertMsg: "",
      alertSeverity: "error",
    };
  }

  componentDidMount() {
    this.props.fetchPartnerDetails();
    plansHelper.setAllPlans();
    this.getAnalytics();
  }

  componentDidUpdate(prevProps) {
    const loginUserId = this.props.agent.agentId;

    // Check if partnerAgents has just been populated
    if (
      Object.keys(this.props.partnerAgents || {}).length > 0 &&
      Object.keys(prevProps.partnerAgents || {}).length === 0
    ) {
      // ✅ Find the matching agent from partnerAgents using loginUserId
      const matchedAgent = this.props.partnerAgents[loginUserId];

      if (!matchedAgent) {
        console.warn(`⚠️ No agent found for loginUserId: ${loginUserId}`);
        return;
      }

      intercomService
        .initializeForUser({
          isAuthenticated: true,
          updatedAgent: matchedAgent,
        })
        .then(() => {
          intercomService.debugIntercomStatus();

          if (
            this.props.loginUser &&
            Object.keys(this.props.agents || {}).length > 0
          ) {
            sendIntercomAttributesAfterLogin(matchedAgent);
            this._intercomAttributesSent = true;

            intercomService.trackCustomEvent("user_logged_in", {
              status: true,
            });
          }
        })
        .catch((error) => {
          console.error("❌ [Intercom] Initialization failed:", error);
        });
    }
  }

  redirectToPayment = (currency) => {
    const { partnerDetail } = this.props;
    const { _id: partnerId } = partnerDetail;

    const blockedPartnerIds = ["690c53e87fa2c70d608d7d69"];

    if (
      !TENANT_ID &&
      currency === "INR" &&
      !blockedPartnerIds.includes(partnerId)
    ) {
      this.setState({ rechargeModalOpen: true });
      return;
    }

    // Fallback: existing WhatsApp redirect flow
    let url;
    TENANT_ID
      ? (url =
        !currency || currency === "INR"
          ? "https://api.whatsapp.com/send?phone=918882171216&text=I%20want%20to%20recharge(%E2%82%B9)%20my%20Partner%20Dashboard%20account."
          : "https://api.whatsapp.com/send?phone=918882171216&text=I%20want%20to%20recharge(%24)%20my%20Partner%20Dashboard%20account.")
      : (url =
        !currency || currency === "INR"
          ? "https://api.whatsapp.com/send?phone=917835901130&text=I%20want%20to%20recharge(%E2%82%B9)%20my%20Partner%20Dashboard%20account."
          : "https://api.whatsapp.com/send?phone=917835901130&text=I%20want%20to%20recharge(%24)%20my%20Partner%20Dashboard%20account.");

    window.open(url, "_blank");
  };

  getAnalytics = async () => {
    try {
      const { startDate, endDate } = this.state;
      const { partnerDetail } = this.props;
      const { _id: partnerId, currency } = partnerDetail;
      let url = partnerURL + `/partner/${partnerId}/credit-usage?`;
      if (startDate) url += `&startDate=${startDate}`;
      if (endDate) url += `&endDate=${endDate}`;
      const response = await axios.get(url);

      const usage = response.data?.usage || [];

      const currencySign = currency === "USD" ? "$" : "₹";
      const roundNumber = (value) =>
        currencySign + (value ? (value / 100000).toFixed(2) : "0");

      for (const key in usage) usage[key] = roundNumber(usage[key]);
      this.setState({ usage, isLoading: false });
    } catch (error) {
      console.log("Fetch analytics failed ->", error);
      this.setState({ isLoading: false });
    }
  };

  setDateRange = (startDate, endDate) => {
    if (startDate && endDate) this.setState({ startDate, endDate });
  };

  setFocus = (focusedInput) => {
    const picker = document.getElementsByClassName("DateInput");
    if (picker[0])
      picker[0].style.border =
        focusedInput === "startDate" ? "1px solid grey" : "1px solid lightgrey";
    if (picker[1])
      picker[1].style.border =
        focusedInput === "endDate" ? "1px solid grey" : "1px solid lightgrey";
    this.setState({ focusedInput });
  };

  onButtonClick = () => {
    window.open("https://help.aisensy.com/en/", "_blank");
  };

  onButtonClick2 = () => {
    window.open("https://intercom.help/aisensy-partners/en/", "_blank");
  };

  render() {
    const {
      classes,
      isPartnerDetailLoading,
      partnerDetail,
      agent,
      partnerAgents,
    } = this.props;

    const { currency, centralBalance, centralAdsBalance } = partnerDetail;
    const { usage, startDate, endDate, focusedInput, isLoading } = this.state;
    const currencySign = currency === "USD" ? "$" : "₹";

    const hasReadAccess = checkAccess(
      partnerDetail,
      partnerAgents,
      agent,
      "dashboard",
      "read",
    );

    const hasWriteAccess = true;

    const isOwner = checkAccess(null, partnerAgents, agent, null, null);

    return (
      <div className={classes.root}>
        {isPartnerDetailLoading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="50vh"
          >
            <CircularProgress />
          </Box>
        ) : (
          <div className={classes.root}>
            <Header
              businessTitle={"Partner Dashboard"}
              hasReadAccess={hasReadAccess}
              hasWriteAccess={hasWriteAccess}
              buttonTitle={
                Object.keys(this.props.tenantDetails).length
                  ? null
                  : "AiSensy Help Center"
              }
              onButtonClick={this.onButtonClick}
              buttonTitle2={
                Object.keys(this.props.tenantDetails).length
                  ? null
                  : "Partner Help Center"
              }
              onButtonClick2={this.onButtonClick2}
            />

            <Box my={3} />
            {/* Layout */}
            <Grid container justify="center">
              <Grid item xs={12} md={11}>
                {hasReadAccess ? (
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                      {!agent.isReferral ? (
                        <Box className={classes.container}>
                          <Typography variant="h4" color="primary">
                            Centralised Balance Management
                          </Typography>
                          <Box mt={3} />
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="end"
                          >
                            <Typography variant="body1" color="textPrimary">
                              Current Balance
                              {(partnerDetail?.type === "WHITELABEL" ||
                                partnerDetail?.type === "ADS_WHITELABEL" ||
                                partnerDetail?.type === "DIRECT") && (
                                  <TooltipIcon
                                    copyKey={
                                      partnerDetail.type === "DIRECT"
                                        ? "DIRECT_API"
                                        : "WHITELABEL"
                                    }
                                  />
                                )}
                            </Typography>
                            <Typography variant="h3" color="primary">
                              {currency === "USD" ? "$" : "₹"}
                              {centralBalance / 100000}
                            </Typography>
                          </Box>

                          <Box mt={2} />

                          <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              if (!isOwner) {
                                this.setState({
                                  alert: true,
                                  alertMsg:
                                    "You need owner access to recharge CB.",
                                  alertSeverity: "error",
                                });
                                return;
                              }
                              this.redirectToPayment(partnerDetail?.currency);
                            }}
                            style={{
                              maxWidth: "300px",
                              margin: "auto",
                              display: "block",
                            }}
                          >
                            Recharge Now
                          </Button>

                          {/* Cashfree Recharge Modal */}
                          <RechargeModal
                            open={this.state.rechargeModalOpen}
                            onClose={() =>
                              this.setState({ rechargeModalOpen: false })
                            }
                            partnerDetail={partnerDetail}
                            fetchPartnerDetails={this.props.fetchPartnerDetails}
                          />
                          {/* <Box textAlign="center" mt={1}>
                        <Typography
                          variant="body1"
                          color="textSecondary"
                          onClick={() => {}}
                          className={classes.viewOldButton}
                        >
                          View Previous Invoices →
                        </Typography>
                      </Box> */}
                        </Box>
                      ) : (
                        <Box
                          className={classes.container}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "25px",
                          }}
                        >
                          <Typography variant="h4" color="primary">
                            Referral Link :-
                          </Typography>
                          <Typography variant="h3" color="primary">
                            {agent.referralLink}
                          </Typography>
                          <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            onClick={() =>
                              navigator.clipboard.writeText(agent.referralLink)
                            }
                            style={{
                              maxWidth: "100px",
                            }}
                          >
                            Copy Link
                          </Button>
                        </Box>
                      )}
                      {partnerDetail?.type === "DIRECT" && (
                        <Box className={classes.container} mt={2}>
                          <Typography variant="h4" color="primary">
                            Centralised Ads Balance
                          </Typography>
                          <Box mt={3} />
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="end"
                          >
                            <Typography variant="body1" color="textPrimary">
                              Current Ads Balance
                            </Typography>
                            <Typography variant="h3" color="primary">
                              {currencySign}
                              {((centralAdsBalance ?? 0) / 100000).toFixed(2)}
                            </Typography>
                          </Box>
                          <Box mt={1} />
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            align="center"
                          >
                            Contact your AiSensy account manager to recharge ads balance.
                          </Typography>
                        </Box>
                      )}
                      {!agent.isReferral && (
                        <Box className={classes.container}>
                          <Grid
                            container
                            spacing={2}
                            style={{ marginBottom: 8 }}
                            alignItems="center"
                            justifyContent={"space-between"}
                          >
                            <Typography
                              variant="h4"
                              color="primary"
                              xs={12}
                              sm={6}
                            >
                              WhatsApp Usage
                            </Typography>
                            <Box
                              xs={12}
                              sm={6}
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <DateFilter
                                startDate={startDate}
                                endDate={endDate}
                                focusedInput={focusedInput}
                                setDate={this.setDateRange}
                                setFocus={this.setFocus}
                                classes={classes}
                                minDate={moment(new Date("03/25/2023"))}
                              />
                              <Button
                                color="primary"
                                variant="contained"
                                onClick={() => {
                                  this.setState({ isLoading: true });
                                  this.getAnalytics();
                                }}
                                disabled={!startDate || !endDate}
                                style={{ marginLeft: 10, padding: "0px 20px" }}
                                endIcon={
                                  isLoading && (
                                    <CircularProgress
                                      style={{ color: "white" }}
                                      size={16}
                                    />
                                  )
                                }
                              >
                                Apply
                              </Button>
                            </Box>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={3}>
                              <Box
                                border="1px solid lightgrey"
                                className={classes.container}
                                textAlign="center"
                              >
                                <Typography variant="h3" color="primary">
                                  {usage?.cbMc || `${currencySign}0`}
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Marketing Central
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Balance Usage
                                </Typography>
                              </Box>
                            </Grid>

                            <Grid item xs={12} md={3}>
                              <Box
                                border="1px solid lightgrey"
                                className={classes.container}
                                textAlign="center"
                              >
                                <Typography variant="h3" color="primary">
                                  {usage?.tcMc || `${currencySign}0`}
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Marketing Template
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Credit Usage
                                </Typography>
                              </Box>
                            </Grid>

                            <Grid item xs={12} md={3}>
                              <Box
                                border="1px solid lightgrey"
                                className={classes.container}
                                textAlign="center"
                              >
                                <Typography variant="h3" color="primary">
                                  {usage?.cbMlc || `${currencySign}0`}
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Marketing Lite Central
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Balance Usage
                                </Typography>
                              </Box>
                            </Grid>

                            <Grid item xs={12} md={3}>
                              <Box
                                border="1px solid lightgrey"
                                className={classes.container}
                                textAlign="center"
                              >
                                <Typography variant="h3" color="primary">
                                  {usage?.tcMlc || `${currencySign}0`}
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Marketing Lite Template
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Credit Usage
                                </Typography>
                              </Box>
                            </Grid>

                            <Grid item xs={12} md={3}>
                              <Box
                                border="1px solid lightgrey"
                                className={classes.container}
                                textAlign="center"
                              >
                                <Typography variant="h3" color="primary">
                                  {usage?.cbUc || `${currencySign}0`}
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Utility Central
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Balance Usage
                                </Typography>
                              </Box>
                            </Grid>

                            <Grid item xs={12} md={3}>
                              <Box
                                border="1px solid lightgrey"
                                className={classes.container}
                                textAlign="center"
                              >
                                <Typography variant="h3" color="primary">
                                  {usage?.tcUc || `${currencySign}0`}
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Utility Template
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Credit Usage
                                </Typography>
                              </Box>
                            </Grid>

                            <Grid item xs={12} md={3}>
                              <Box
                                border="1px solid lightgrey"
                                className={classes.container}
                                textAlign="center"
                              >
                                <Typography variant="h3" color="primary">
                                  {usage?.cbAc || `${currencySign}0`}
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Authentication Central
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Balance Usage
                                </Typography>
                              </Box>
                            </Grid>

                            <Grid item xs={12} md={3}>
                              <Box
                                border="1px solid lightgrey"
                                className={classes.container}
                                textAlign="center"
                              >
                                <Typography variant="h3" color="primary">
                                  {usage?.tcAc || `${currencySign}0`}
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Authentication Template
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Credit Usage
                                </Typography>
                              </Box>
                            </Grid>

                            <Grid item xs={12} md={3}>
                              <Box
                                border="1px solid lightgrey"
                                className={classes.container}
                                textAlign="center"
                              >
                                <Typography variant="h3" color="primary">
                                  {usage?.cbSc || `${currencySign}0`}
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Service Central
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Balance Usage
                                </Typography>
                              </Box>
                            </Grid>

                            <Grid item xs={12} md={3}>
                              <Box
                                border="1px solid lightgrey"
                                className={classes.container}
                                textAlign="center"
                              >
                                <Typography variant="h3" color="primary">
                                  {usage?.tcSc || `${currencySign}0`}
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Service Template
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  Credit Usage
                                </Typography>
                              </Box>
                            </Grid>
                          </Grid>

                          {/* <Grid container spacing={2}> */}
                          {/* <Grid item xs={12} md={3}>
                              <Box
                                border="1px solid lightgrey"
                                className={classes.container}
                                textAlign="center"
                              >
                                <Typography variant="h3" color="primary">
                                  {usage?.cbBic || `${currencySign}0`}
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  BIC Central Balance Usage
                                </Typography>
                              </Box>
                            </Grid>

                            <Grid item xs={12} md={3}>
                              <Box
                                border="1px solid lightgrey"
                                className={classes.container}
                                textAlign="center"
                              >
                                <Typography variant="h3" color="primary">
                                  {usage?.tcBic || `${currencySign}0`}
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  BIC Template Credit Usage
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={12} md={3}>
                              <Box
                                border="1px solid lightgrey"
                                className={classes.container}
                                textAlign="center"
                              >
                                <Typography variant="h3" color="primary">
                                  {usage?.cbUic || `${currencySign}0`}
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  UIC Central Balance Usage
                                </Typography>
                              </Box>
                            </Grid>

                            <Grid item xs={12} md={3}>
                              <Box
                                border="1px solid lightgrey"
                                className={classes.container}
                                textAlign="center"
                              >
                                <Typography variant="h3" color="primary">
                                  {usage?.tcUic || `${currencySign}0`}
                                </Typography>
                                <Typography variant="body1" color="textPrimary">
                                  UIC Template Credit Usage
                                </Typography>
                              </Box>
                            </Grid> */}

                          {/*   <Grid item xs={12} md={6}>
                          <Box
                            border="1px solid lightgrey"
                            className={classes.container}
                            textAlign="center"
                          >
                            <Typography variant="h3" color="primary">
                              {usage?.cbUic || `${currencySign}0`}
                            </Typography>
                            <Typography variant="body1" color="textPrimary">
                              UIC Central Balance Usage
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Box
                            border="1px solid lightgrey"
                            className={classes.container}
                            textAlign="center"
                          >
                            <Typography variant="h3" color="primary">
                              {usage?.tcUic || `${currencySign}0`}
                            </Typography>
                            <Typography variant="body1" color="textPrimary">
                              UIC Template Credit Usage
                            </Typography>
                          </Box>
                        </Grid> */}
                          {/* </Grid> */}
                        </Box>
                      )}

                      {!agent.isReferral && (
                        <Grid
                          container
                          className={classes.container}
                          textAlign="center"
                        >
                          <Grid
                            item
                            xs={12}
                            md={6}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <Typography variant="h3" color="primary">
                              {currencySign}
                              {(partnerDetail?.minAllowedBalance ?? "0") /
                                100000}
                            </Typography>
                            <Typography variant="body1" color="textPrimary">
                              Min Balance Allowance
                              <TooltipIcon copyKey="MIN_BALANCE" />
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={6}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <Typography variant="h3" color="primary">
                              {partnerDetail?.liveAccounts ?? "_"}
                            </Typography>
                            <Typography variant="body1" color="textPrimary">
                              WhatsApp Account Live
                            </Typography>
                          </Grid>
                        </Grid>
                      )}
                    </Grid>

                    {/* <Grid item xs={12} md={6}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Box className={classes.container} textAlign="center">
                          <Typography variant="h3" color="primary">
                            {partnerDetail?.liveAccounts ?? "_"}
                          </Typography>
                          <Typography variant="body1" color="textPrimary">
                            WhatsApp Account Live
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Box className={classes.container} textAlign="center">
                          <Typography variant="h3" color="primary">
                            <FiberManualRecord
                              style={{
                                color: "#08CF65",
                                fontSize: 16,
                                position: "relative",
                                top: 1.5,
                                right: 3,
                              }}
                            />{" "}
                            Online
                          </Typography>
                          <Typography variant="body1" color="textPrimary">
                            WhatsApp API Status
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>

                    <Box
                      className={classes.container}
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Typography variant="h4" color="textPrimary">
                        Setup Your White Label Dashboard
                      </Typography>
                      <Button variant="contained" color="primary">
                        Apply Now
                      </Button>
                    </Box>

                    <Box
                      className={classes.container}
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Typography variant="h4" color="textPrimary">
                        Explore WhatsApp API's
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        target="_blank"
                        href="https://aisensy.stoplight.io/docs/partner-api/67fb491f16f99-getting-started"
                      >
                        Explore Now
                      </Button>
                    </Box>

                    <Box className={classes.container}>
                      <Typography variant="h3" color="textPrimary">
                        Updates from WhatsApp
                      </Typography>
                      <Box mt={2} />
                      <Typography
                        variant="body1"
                        color="textPrimary"
                        gutterBottom
                      >
                        • WhatsApp Commerce APIs are now Live
                      </Typography>
                      <Typography
                        variant="body1"
                        color="textPrimary"
                        gutterBottom
                      >
                        • Soon Launching WhatsApp Payments
                      </Typography>
                    </Box>
                  </Grid> */}
                  </Grid>
                ) : (
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      textAlign: "center",
                      height: "50vh",
                      alignItems: "center",
                      // backgroundColor: "#f5f5f5",
                      borderRadius: "10px",
                      padding: "20px",
                    }}
                  >
                    <LockIcon
                      style={{
                        fontSize: 90,
                        color: "grey",
                        marginBottom: "10px",
                      }}
                    />
                    <Typography variant="h4" color="textSecondary">
                      Access Denied
                    </Typography>
                    <Typography variant="subtitle1" color="textSecondary">
                      Looks like you don't have the necessary permissions to
                      view this page
                    </Typography>
                    <Typography variant="subtitle2" color="textSecondary">
                      Please contact your administrator for more information.
                    </Typography>
                  </Box>
                )}
              </Grid>
            </Grid>
            <Box my={8} />
          </div>
        )}
        <Snackbar
          open={this.state.alert}
          autoHideDuration={3000}
          onClose={() => this.setState({ alert: false })}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={() => this.setState({ alert: false })}
            severity={this.state.alertSeverity}
          >
            {this.state.alertMsg}
          </Alert>
        </Snackbar>
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    width: "100%",
    height: "100%",
    // background: "red",
    // display: "flex",
    background: "rgb(247,247,247)",
    boxSizing: "border-box",
    overflowX: "hidden",
    position: "relative",
    // paddingBottom: "80px"
  },
  pageTitleContainer: {
    position: "sticky",
    zIndex: 100,
    top: 0,
    height: 60,
    boxSizing: "border-box",
    [theme.breakpoints.down("md")]: {
      // paddingTop: "40px",
    },
    [theme.breakpoints.down("sm")]: {
      // paddingTop: "20px",
    },
  },
  fullWidth: {
    width: "100%",
    background: "white",
  },
  primaryBackground: {
    background: "rgb(70 20 134 / 15%)",
  },
  container: {
    marginTop: 16,
    background: "white",
    borderRadius: 8,
    padding: "24px 36px",
  },
  viewOldButton: {
    "&:hover": {
      color: "grey",
      cursor: "pointer",
    },
  },
});

// export default withStyles(styles)(Dashboard);

const connectDashboard = connect(
  (state) => ({
    isPartnerDetailLoading: state.partner.isLoading,
    partnerDetail: state.partner.partner,
    agent: state.login.user,
    tenantDetails: state.tenant.tenant,
    partnerAgents: state.partnerAgents.partnerAgents,
  }),
  {
    fetchPartnerDetails,
  },
)(Dashboard);

export default withStyles(styles)(connectDashboard);
